import { BudgetAllocationsCheck, BudgetChartBudgets, Id } from 'src/types'

import Api, { make, Response } from '.'

interface BudgetAllocationsCheckResponse {
  budgets: BudgetChartBudgets[]
  policy_rule_id: Id
}

async function getBudgetAllocationsCheck(
  budget_allocations: BudgetAllocationsCheck
): Promise<Response<BudgetAllocationsCheckResponse>> {
  const url = `budgets/allocation/check`
  return make<BudgetAllocationsCheckResponse>({
    axiosCall: Api.post(url, {
      budget_allocations
    })
  })
}

interface BudgetAllocationsRequestResponse {
  budgets: BudgetChartBudgets[]
}

async function getBudgetAllocationsRequest(
  requestId: Id
): Promise<Response<BudgetAllocationsRequestResponse>> {
  const url = `budgets/allocation/request/${requestId}`
  return make<BudgetAllocationsRequestResponse>({
    axiosCall: Api.get(url)
  })
}

export default { getBudgetAllocationsCheck, getBudgetAllocationsRequest }
